/**
 * ScenarioProposalCard — the confirm step for an agent-proposed what-if.
 *
 * Rendered under a chat message whose `action.type === "run_scenario"`. Shows the
 * human-readable exclusion, the row/exposure impact, and Run / Dismiss buttons.
 * The run is the expensive step, so it only fires on explicit confirmation.
 */
const money = (n) => {
  if (n === null || n === undefined || isNaN(n)) return null;
  const a = Math.abs(n);
  return a >= 1e6 ? `$${(n / 1e6).toFixed(1)}M` : a >= 1e3 ? `$${(n / 1e3).toFixed(0)}K` : `$${n.toFixed(0)}`;
};

const describeSpec = (spec) => {
  const parts = [];
  (spec.excludeFilters || []).forEach((f) =>
    parts.push(`Exclude ${f.col} ∈ {${(f.values || []).join(", ")}}`)
  );
  (spec.binaryFilters || []).forEach((f) =>
    parts.push(`Keep only ${f.col} ∈ {${(f.values || []).join(", ")}}`)
  );
  (spec.regexFilters || []).forEach((f) => parts.push(`${f.col} matches /${f.pattern}/`));
  return parts;
};

const ScenarioProposalCard = ({ action, disabled, onRun, onDismiss }) => {
  const { name, spec, preview = {}, consumed } = action;
  const removedAmt = money(preview.removedAmount);

  return (
    <div
      style={{
        border: "1px solid var(--ev-border)",
        borderLeft: "3px solid #79589F",
        borderRadius: "8px",
        padding: "0.7rem 0.8rem",
        backgroundColor: "var(--ev-white)",
        fontSize: "0.78rem",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.4rem", marginBottom: "0.4rem" }}>
        <i className="fa-duotone fa-flask" style={{ color: "#79589F" }} />
        <span style={{ fontWeight: 700, color: "var(--ev-text)" }}>{name}</span>
      </div>

      {describeSpec(spec).map((line, i) => (
        <div key={i} style={{ color: "var(--ev-text)", marginBottom: "0.15rem" }}>
          <i className="fa-solid fa-filter" style={{ fontSize: "0.62rem", marginRight: "0.35rem", opacity: 0.5 }} />
          {line}
        </div>
      ))}

      {preview.removedRows !== undefined && (
        <div style={{ color: "var(--ev-text-muted)", margin: "0.4rem 0" }}>
          Removes <strong>{preview.removedRows?.toLocaleString()}</strong> of{" "}
          {preview.baseRows?.toLocaleString()} rows
          {preview.removedPct !== undefined && <> ({preview.removedPct}%)</>}
          {removedAmt && (
            <> · <strong>{removedAmt}</strong> exposure{preview.removedAmountPct !== undefined && <> ({preview.removedAmountPct}%)</>}</>
          )}
        </div>
      )}

      {consumed ? (
        <div style={{ color: "var(--ev-text-muted)", fontStyle: "italic", marginTop: "0.3rem" }}>
          <i className="fa-solid fa-check" style={{ marginRight: "0.3rem" }} />
          Scenario created.
        </div>
      ) : (
        <div style={{ display: "flex", gap: "0.4rem", marginTop: "0.5rem" }}>
          <button
            className="button is-small"
            onClick={onRun}
            disabled={disabled}
            style={{ backgroundColor: "#79589F", color: "#fff", border: "none", fontWeight: 700, borderRadius: "6px" }}
          >
            <i className="fa-solid fa-play" style={{ marginRight: "0.35rem" }} />
            Run scenario
          </button>
          <button
            className="button is-small is-light"
            onClick={onDismiss}
            disabled={disabled}
            style={{ borderRadius: "6px" }}
          >
            Dismiss
          </button>
        </div>
      )}
    </div>
  );
};

export default ScenarioProposalCard;
